const log = {
    invalid_type: 'ログタイプが無効です。',
    invalid_time_window: '`end_time` は `start_time` より後である必要があります。',
};
export default Object.freeze(log);
